import React from 'react';
import Spinner from './Spinner';
import SortDrawer from './SortDrawer';
import Pagination from './Pagination';
import ToolCard from './ToolCard';

const DiscoverPage = ({
  search,
  setSearch,
  loading,
  tools,
  currentTools,
  currentPage,
  totalPages,
  setCurrentPage,
  showSortOptions,
  setShowSortOptions,
  setDrawerHeight,
  drawerHeight,
  sortOptions,
  setSortOptions,
  sortOrder,
  setSortOrder,
  navigate,
}) => {
  const cardContainerStyle = {
    marginTop: `${drawerHeight}px`,
    transition: "margin-top 0.3s ease-in-out",
    minHeight: loading || tools.length === 0 ? "80vh" : "auto",
  };

  return (
    <>
      <div className="relative">
        <div className="flex items-center mb-4 ">
          <input
            type="text"
            placeholder="Search AI Planners"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-14946d focus:border-14946d input-field"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <SortDrawer
            showSortOptions={showSortOptions}
            setShowSortOptions={setShowSortOptions}
            setDrawerHeight={setDrawerHeight}
            drawerHeight={drawerHeight}
            sortOptions={sortOptions}
            setSortOptions={setSortOptions}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
          />
        </div>
      </div>

      <div
        className="relative"
        style={{
          marginTop: `${drawerHeight + 10}px`,
          transition: "margin-top 0.3s ease-in-out",
        }}
      >
        <div
          className="cards-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 pb-16"
          style={cardContainerStyle}
        >
          {loading ? (
            <div
              className="center-spinner"
              style={{ minHeight: "80vh" }}
            >
              <Spinner />
            </div>
          ) : currentTools.length === 0 ? (
            <div
              className="col-span-3 flex justify-center items-center h-64"
              style={{ minHeight: "80vh" }}
            >
              <p>No tools found</p>
            </div>
          ) : (
            currentTools.map((tool) => (
              <ToolCard
                key={tool.id}
                tool={tool}
                navigate={navigate}
              />
            ))
          )}
        </div>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </>
  );
};

export default DiscoverPage;
